var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyhole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1823 0L0 15.081H4.299V33.081H31.299V15.081H36L18.1823 0ZM22.2555 27.831H13.7438L15.5287 19.7977C14.4495 19.0477 13.7438 17.9182 13.7438 16.5352C13.7438 14.2567 15.6495 12.456 17.9993 12.456C20.3505 12.456 22.2555 14.3258 22.2555 16.6042C22.2555 17.988 21.5497 19.038 20.4713 19.7858L22.2555 27.831Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyhole);
export default __webpack_public_path__ + "static/media/keyhole.537c6d8b22e4e4fdafff875a06cce6f6.svg";
export { ForwardRef as ReactComponent };